import { render, staticRenderFns } from "./SangomaAILoader.vue?vue&type=template&id=a4fca058&scoped=true&"
import script from "./SangomaAILoader.vue?vue&type=script&lang=js&"
export * from "./SangomaAILoader.vue?vue&type=script&lang=js&"
import style0 from "./SangomaAILoader.vue?vue&type=style&index=0&id=a4fca058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fca058",
  null
  
)

export default component.exports